import {Image, ImageProps} from '@chakra-ui/react';

import coinsBagIcon from './coins-bag-icon.png';

export const CoinsBagIcon = (props: ImageProps) => (
  <Image src={coinsBagIcon.src} alt="" objectFit="contain" {...props} />
);
